/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'

import 'react-three-fiber'

function Base({ type = '1b', position = [0, 0, 3] }) {
    const mesh = useRef()
    const homePlate = {
        x: 0,
        y: 0,
    }
    const n = Math.sqrt((90 * 90) / 2)
    const baseRadius = Math.sqrt(2)

    const basePosition = {}
    if (type === '1b') {
        basePosition.x = position[0] + (homePlate.x + n - baseRadius)
        basePosition.y = homePlate.y + n
    }
    if (type === '2b') {
        basePosition.x = position[0] + homePlate.x
        basePosition.y = homePlate.y + 2 * n
    }
    if (type === '3b') {
        basePosition.x = position[0] + (homePlate.x - n + baseRadius)
        basePosition.y = homePlate.y + n
    }
    const rotationZ = 0.25 * Math.PI

    const geometry = new THREE.BoxGeometry(2, 2, 0.5)
    const material = new THREE.MeshLambertMaterial({ color: 0xc2c2c2 })

    return (
        <mesh
            ref={mesh}
            rotation={[0, 0, rotationZ]}
            name={`base_${type}`}
            position={[basePosition.x, basePosition.y, 6]}
            geometry={geometry}
            material={material}
        />
    )
}

export default Base
